import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { startWith, exhaustMap, materialize, switchMap, dematerialize, finalize, tap } from 'rxjs/operators';
import { faBell, faExclamation } from '@fortawesome/free-solid-svg-icons';
import { BehaviorSubject, interval, NEVER } from 'rxjs';
import * as i2 from '@angular/router';
import { NavigationEnd } from '@angular/router';
import { HttpHelpers } from '@surescripts/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import * as i5 from '@fortawesome/angular-fontawesome';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

class NotificationsService {
    constructor() { }
    static { this.ɵfac = function NotificationsService_Factory(t) { return new (t || NotificationsService)(); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: NotificationsService, factory: NotificationsService.ɵfac, providedIn: 'root' }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], () => [], null); })();

class SurescriptsNotification {
    constructor(init) {
        Object.assign(this, init);
        this.postedDate = new Date(init.postedDate);
        const difference = new Date().getTime() - this.postedDate.getTime();
        if (difference <= 3600000) {
            const minutes = Math.round(((difference % 86400000) % 3600000) / 60000);
            if (minutes < 2) {
                this.readablePostedDate = 'Moments ago';
            }
            else {
                this.readablePostedDate = `${minutes} minutes ago`;
            }
        }
        else if (difference <= 86400000) {
            const hours = Math.floor((difference % 86400000) / 3600000);
            if (hours < 2) {
                this.readablePostedDate = `${hours} hour ago`;
            }
            else {
                this.readablePostedDate = `${hours} hours ago`;
            }
        }
        else if (difference <= 604800000) {
            const days = Math.floor(difference / 86400000);
            if (days < 2) {
                this.readablePostedDate = `${days} day ago`;
            }
            else {
                this.readablePostedDate = `${days} days ago`;
            }
        }
    }
}

class SurescriptsNotifications {
    constructor(init) {
        Object.assign(this, init);
        this.items = init.items.map(x => new SurescriptsNotification(x));
    }
}

var SurescriptsNotificationStatus;
(function (SurescriptsNotificationStatus) {
    SurescriptsNotificationStatus["Read"] = "Read";
    SurescriptsNotificationStatus["Unread"] = "Unread";
})(SurescriptsNotificationStatus || (SurescriptsNotificationStatus = {}));

const _c0 = () => ["fa-custom-counter"];
function NotificationsComponent_fa_layers_counter_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-layers-counter", 15);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("content", ctx_r0.unreadCount > 9 ? "9+" : ctx_r0.unreadCount)("classes", i0.ɵɵpureFunction0(2, _c0));
} }
function NotificationsComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 16);
    i0.ɵɵtext(1, "unread messages");
    i0.ɵɵelementEnd();
} }
function NotificationsComponent_li_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 17)(1, "span");
    i0.ɵɵtext(2, "No notifications at this time.");
    i0.ɵɵelementEnd()();
} }
function NotificationsComponent_li_13_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 27);
    i0.ɵɵtext(1, "Priority");
    i0.ɵɵelementEnd();
} }
function NotificationsComponent_li_13_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 18);
    i0.ɵɵlistener("click", function NotificationsComponent_li_13_Template_li_click_0_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r8); const notification_r4 = restoredCtx.$implicit; const ctx_r7 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r7.dismiss($event, notification_r4, true)); });
    i0.ɵɵelementStart(1, "h6", 19);
    i0.ɵɵtemplate(2, NotificationsComponent_li_13_span_2_Template, 2, 0, "span", 20);
    i0.ɵɵelementStart(3, "span", 21);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "p", 22);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 23)(8, "small", 24);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "small", 25)(12, "a", 26);
    i0.ɵɵlistener("click", function NotificationsComponent_li_13_Template_a_click_12_listener($event) { const restoredCtx = i0.ɵɵrestoreView(_r8); const notification_r4 = restoredCtx.$implicit; const ctx_r9 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r9.dismiss($event, notification_r4)); });
    i0.ɵɵtext(13, "Mark as Read");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const notification_r4 = ctx.$implicit;
    i0.ɵɵpropertyInterpolate("id", notification_r4 == null ? null : notification_r4.id);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", notification_r4.isPriority);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "", notification_r4 == null ? null : notification_r4.id, "-notification-title");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(notification_r4.title);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("title", notification_r4.summary);
    i0.ɵɵpropertyInterpolate1("id", "", notification_r4 == null ? null : notification_r4.id, "-notification-summary");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(notification_r4.summary);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(notification_r4.readablePostedDate || i0.ɵɵpipeBind2(10, 9, notification_r4.postedDate, "shortDate"));
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "", notification_r4 == null ? null : notification_r4.id, "-notification-dismiss");
} }
const _c1 = () => ["bottom", "bottom-right"];
/**
  * Example of usage:
  * <example-url>../assets/examples/shared/example-component-launch-sb.html?component=notifications</example-url>
  */
class NotificationsComponent {
    constructor(http, router) {
        this.http = http;
        this.router = router;
        this.faBell = faBell;
        this.faExclamation = faExclamation;
        this.unreadCount = 0;
        this.SurescriptsNotificationStatus = SurescriptsNotificationStatus;
    }
    ngOnInit() {
        if (!this.ssoBaseUrl && !this.baseDataUrl) {
            // Set default value to match backend middleware.
            this.baseRequestUrl = "/shared/notifications";
        }
        else if (!this.baseDataUrl) {
            console.warn("ssoBaseUrl is deprecated and has been replaced by baseDataUrl");
            this.ssoBaseUrl = this.ssoBaseUrl.replace(/\/+$/, '');
            this.baseRequestUrl = `${this.ssoBaseUrl}/app/v1/user/notifications`;
        }
        else {
            this.baseDataUrl = this.baseDataUrl.replace(/\/+$/, '');
            this.baseRequestUrl = this.baseDataUrl;
        }
        const pauser = new BehaviorSubject(false);
        // poll every hour.
        const source = interval(3600000).pipe(startWith(0), exhaustMap(() => this.poll()));
        pauser.pipe(switchMap(paused => paused ? NEVER : source.pipe(materialize())), dematerialize()).subscribe();
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // pause the poll and make a call. once finished, turn the poll on again and unsubscribe
                pauser.next(true);
                this.poll().pipe(finalize(() => {
                    pauser.next(false);
                })).subscribe().unsubscribe();
            }
        });
    }
    poll() {
        return HttpHelpers.spinnerDisabledGet(this.http, this.baseRequestUrl)
            .pipe(tap((resp) => {
            this.notifications = new SurescriptsNotifications(resp);
            this.unreadCount = this.notifications.items.filter(x => x.status === SurescriptsNotificationStatus.Unread).length;
        }));
    }
    dismiss($event, item, viewNotification = false) {
        const index = this.notifications.items.indexOf(item);
        $event.stopPropagation();
        if (index >= 0) {
            this.http.put(`${this.baseRequestUrl}/${item.id}/dismiss`, null, { withCredentials: true }).pipe(tap(() => {
                this.notifications.items.splice(index, 1);
                if (item.status === SurescriptsNotificationStatus.Unread) {
                    this.unreadCount = this.unreadCount - 1;
                }
            })).subscribe(() => {
                if (viewNotification) {
                    window.location.href = `${this.notifications?.baseUrl}/notifications/${item.id}`;
                }
            });
        }
    }
    static { this.ɵfac = function NotificationsComponent_Factory(t) { return new (t || NotificationsComponent)(i0.ɵɵdirectiveInject(i1.HttpClient), i0.ɵɵdirectiveInject(i2.Router)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: NotificationsComponent, selectors: [["surescripts-notifications"]], inputs: { ssoBaseUrl: "ssoBaseUrl", baseDataUrl: "baseDataUrl" }, decls: 17, vars: 11, consts: [["ngbDropdown", "", "container", "body", "display", "dynamic", "autoClose", "outside", 1, "d-inline-block", 3, "placement"], ["ngbDropdownToggle", "", "id", "surescripts-notifications-icon-v2", "data-toggle", "dropdown", 1, "nav-link", 3, "title"], ["size", "lg", 3, "fixedWidth"], [3, "icon"], [3, "content", "classes", 4, "ngIf"], ["class", "sr-only", 4, "ngIf"], ["ngbDropdownMenu", "", "id", "notification-dropdown-menu"], [1, "card"], [1, "card-body"], ["id", "notifications-title", 1, "card-title"], [1, "list-group", "list-group-flush"], ["class", "list-group-item flex-column align-items-start", 4, "ngIf"], ["class", "list-group-item notification-body flex-column align-items-start", 3, "id", "click", 4, "ngFor", "ngForOf"], [1, "card-footer", "text-center"], ["id", "view-all-notifications", "title", "View All Notifications", 3, "href"], [3, "content", "classes"], [1, "sr-only"], [1, "list-group-item", "flex-column", "align-items-start"], [1, "list-group-item", "notification-body", "flex-column", "align-items-start", 3, "id", "click"], [1, "mb-1", "text-truncate"], ["class", "priority badge me-2 font-weight-bold", 4, "ngIf"], ["title", "View All Notifications", 3, "id"], [1, "mb-1", "text-truncate", 3, "title", "id"], [1, "d-flex", "w-100", "justify-content-between"], [1, "text-secondary"], [1, "mark-as-read", "text-secondary"], ["href", "javascript:void(0)", 3, "id", "click"], [1, "priority", "badge", "me-2", "font-weight-bold"]], template: function NotificationsComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "a", 1)(2, "fa-layers", 2);
            i0.ɵɵelement(3, "fa-icon", 3);
            i0.ɵɵtemplate(4, NotificationsComponent_fa_layers_counter_4_Template, 1, 3, "fa-layers-counter", 4)(5, NotificationsComponent_span_5_Template, 2, 0, "span", 5);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(6, "div", 6)(7, "div", 7)(8, "div", 8)(9, "h5", 9);
            i0.ɵɵtext(10);
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(11, "ul", 10);
            i0.ɵɵtemplate(12, NotificationsComponent_li_12_Template, 3, 0, "li", 11)(13, NotificationsComponent_li_13_Template, 14, 12, "li", 12);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "div", 13)(15, "a", 14);
            i0.ɵɵtext(16, "View All");
            i0.ɵɵelementEnd()()()()();
        } if (rf & 2) {
            i0.ɵɵproperty("placement", i0.ɵɵpureFunction0(10, _c1));
            i0.ɵɵadvance();
            i0.ɵɵpropertyInterpolate1("title", "", ctx.unreadCount, " unread notifications");
            i0.ɵɵadvance();
            i0.ɵɵproperty("fixedWidth", true);
            i0.ɵɵadvance();
            i0.ɵɵproperty("icon", ctx.faBell);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.unreadCount > 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.unreadCount > 0);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate1("Notifications (", ctx.unreadCount, ")");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", (ctx.notifications == null ? null : ctx.notifications.items == null ? null : ctx.notifications.items.length) === 0);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngForOf", ctx.notifications == null ? null : ctx.notifications.items);
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate1("href", "", ctx.notifications == null ? null : ctx.notifications.baseUrl, "/notifications", i0.ɵɵsanitizeUrl);
        } }, dependencies: [i3.NgForOf, i3.NgIf, i4.NgbDropdown, i4.NgbDropdownToggle, i4.NgbDropdownMenu, i5.FaIconComponent, i5.FaLayersComponent, i5.FaLayersCounterComponent, i3.DatePipe] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationsComponent, [{
        type: Component,
        args: [{ selector: 'surescripts-notifications', template: "<div class=\"d-inline-block\" ngbDropdown container=\"body\"  [placement]=\"['bottom', 'bottom-right']\" display=\"dynamic\" autoClose=\"outside\">\n    <a ngbDropdownToggle class=\"nav-link\" id=\"surescripts-notifications-icon-v2\" title=\"{{unreadCount}} unread notifications\" data-toggle=\"dropdown\">\n        <fa-layers size=\"lg\" [fixedWidth]=\"true\">\n            <fa-icon [icon]=\"faBell\"></fa-icon>\n            <fa-layers-counter [content]=\"unreadCount> 9 ? '9+' : unreadCount\" [classes]=\"['fa-custom-counter']\" *ngIf=\"unreadCount > 0\"></fa-layers-counter>\n          \t<span class=\"sr-only\" *ngIf=\"unreadCount > 0\">unread messages</span>\n        </fa-layers>\n    </a>\n    <div ngbDropdownMenu id=\"notification-dropdown-menu\">\n        <div class=\"card\">\n            <div class=\"card-body\">\n                <h5 class=\"card-title\" id=\"notifications-title\">Notifications ({{unreadCount}})</h5>\n            </div>\n            <ul class=\"list-group list-group-flush\">\n                <li class=\"list-group-item flex-column align-items-start\" *ngIf=\"notifications?.items?.length === 0\">\n                    <span>No notifications at this time.</span>\n                </li>\n                <li class=\"list-group-item notification-body flex-column align-items-start\" id=\"{{notification?.id}}\"\n                    (click)=\"dismiss($event, notification, true)\" *ngFor=\"let notification of notifications?.items; index as j;\">\n                    <h6 class=\"mb-1 text-truncate\">\n                        <span *ngIf=\"notification.isPriority\"\n                            class=\"priority badge me-2 font-weight-bold\">Priority</span>\n                        <span \n                            id=\"{{notification?.id}}-notification-title\"\n                            title=\"View All Notifications\">{{notification.title}}</span>\n                    </h6>\n                    <p class=\"mb-1 text-truncate\" title=\"{{notification.summary}}\"\n                        id=\"{{notification?.id}}-notification-summary\">{{notification.summary}}</p>\n                    <span class=\"d-flex w-100 justify-content-between\">\n                        <small class=\"text-secondary\">{{notification.readablePostedDate || (notification.postedDate |\n                            date:'shortDate') }}</small>\n                        <small class=\"mark-as-read text-secondary\">\n                            <a href=\"javascript:void(0)\" (click)=\"dismiss($event, notification)\"\n                                id=\"{{notification?.id}}-notification-dismiss\">Mark as Read</a>\n                        </small>\n\n                    </span>\n                </li>\n            </ul>\n            <div class=\"card-footer text-center\">\n                <a href=\"{{notifications?.baseUrl}}/notifications\" id=\"view-all-notifications\"\n                    title=\"View All Notifications\">View All</a>\n            </div>\n\n        </div>\n    </div>\n</div>\n" }]
    }], () => [{ type: i1.HttpClient }, { type: i2.Router }], { ssoBaseUrl: [{
            type: Input
        }], baseDataUrl: [{
            type: Input
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(NotificationsComponent, { className: "NotificationsComponent", filePath: "lib/notifications.component.ts", lineNumber: 22 }); })();

class NotificationsModule {
    static { this.ɵfac = function NotificationsModule_Factory(t) { return new (t || NotificationsModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NotificationsModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
            HttpClientModule,
            NgbDropdownModule,
            FontAwesomeModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NotificationsModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    HttpClientModule,
                    NgbDropdownModule,
                    FontAwesomeModule
                ],
                declarations: [NotificationsComponent],
                exports: [NotificationsComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(NotificationsModule, { declarations: [NotificationsComponent], imports: [CommonModule,
        HttpClientModule,
        NgbDropdownModule,
        FontAwesomeModule], exports: [NotificationsComponent] }); })();

/*
 * Public API Surface of notifications
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NotificationsComponent, NotificationsModule, NotificationsService, SurescriptsNotification, SurescriptsNotificationStatus, SurescriptsNotifications };
